'use es6';

import { LAST } from 'conversations-message-history/constants/messagePositionDescriptors';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
import PropTypes from 'prop-types';
import { Fragment, PureComponent } from 'react';
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import { CaptureSection } from './CaptureSection';
import ConsentToCommunicate from './ConsentToCommunicate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isInValidRegex = /\s|@.{0,}@/;
class EmailCapturePromptMessage extends PureComponent {
  constructor(props) {
    super(props);
    this.onConsentChange = () => {
      this.setState({
        hasConsentedToCommunicate: !this.state.hasConsentedToCommunicate
      });
    };
    this.state = {
      email: '',
      emailError: false,
      hasConsentedToCommunicate: false,
      submitFailure: false,
      submissionState: 'ready'
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleChange(event) {
    this.setState({
      email: event.target.value,
      emailError: false,
      submitFailure: false,
      submissionState: 'ready'
    });
  }
  handleKeyPress(event) {
    const ENTER_KEY = 13;
    if (event.which === ENTER_KEY) {
      this.handleSubmit();
    }
  }
  handleSubmit() {
    const {
      sendVisitorEmailAddress,
      threadId
    } = this.props;
    const {
      email,
      hasConsentedToCommunicate: consentToCommunicate
    } = this.state;
    const trimmedEmail = email.trim();
    if (EmailAddressPattern.test(trimmedEmail) && !trimmedEmail.match(isInValidRegex)) {
      this.setState({
        submissionState: 'submitting'
      }, () => {
        sendVisitorEmailAddress({
          email: trimmedEmail,
          consentToCommunicate,
          threadId
        }).then(({
          error
        } = {}) => {
          this.setState({
            submitFailure: Boolean(error),
            submissionState: 'done'
          });
        }).catch(err => {
          setTimeout(() => {
            throw err;
          });
        });
      });
    } else {
      this.setState({
        emailError: true,
        submissionState: 'ready'
      });
    }
  }
  getValidationMessage() {
    switch (true) {
      case this.state.emailError:
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-visitor-message-history.email-capture.invalid"
        });
      case this.state.submitFailure:
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-visitor-message-history.email-capture.failed"
        });
      default:
        return null;
    }
  }
  render() {
    const {
      companyName,
      consentToCommunicateMessage,
      hasVisitorEmail,
      message,
      positionDescriptors,
      requiresConsentToCommunicate
    } = this.props;
    const {
      email,
      hasConsentedToCommunicate
    } = this.state;
    const errorMessage = this.getValidationMessage();
    return /*#__PURE__*/_jsx(PrimaryMessage, {
      use: AGENT,
      children: /*#__PURE__*/_jsx(PrimaryMessageContent, {
        shouldFocusMessage: Boolean(positionDescriptors && positionDescriptors.get(LAST)),
        children: hasVisitorEmail ? /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-test-id": "email-capture-success",
            message: "conversations-visitor-message-history.email-capture.thanks"
          })
        }) : /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(CaptureSection, {
            message: message,
            email: email,
            errorMessage: errorMessage,
            onChange: this.handleChange,
            onKeyPress: this.handleKeyPress,
            onSubmit: this.handleSubmit,
            submissionState: this.state.submissionState
          }), requiresConsentToCommunicate && /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
            children: /*#__PURE__*/_jsx(ConsentToCommunicate, {
              message: consentToCommunicateMessage,
              companyName: companyName,
              consentToCommunicate: hasConsentedToCommunicate,
              onChange: this.onConsentChange
            })
          }, "email-prompt-content-section")]
        })
      })
    });
  }
}
EmailCapturePromptMessage.displayName = 'EmailCapturePromptMessage';
EmailCapturePromptMessage.propTypes = {
  companyName: PropTypes.string,
  consentToCommunicateMessage: PropTypes.string,
  hasVisitorEmail: PropTypes.bool.isRequired,
  message: RecordPropType('EmailCapturePromptMessage').isRequired,
  positionDescriptors: PositionDescriptors.isRequired,
  requiresConsentToCommunicate: PropTypes.bool,
  sendVisitorEmailAddress: PropTypes.func.isRequired,
  threadId: PropTypes.number.isRequired
};
export default EmailCapturePromptMessage;